// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IntegrationAthenaDetailsPopup-module__grid___YuKLP {
  display: grid;
  padding: 15px 30px;
  grid-row-gap: 25px;
  grid-column-gap: 25px;
  grid-template-columns: repeat(3, 1fr);
}
.IntegrationAthenaDetailsPopup-module__grid___YuKLP .IntegrationAthenaDetailsPopup-module__width75___TeBFs {
  grid-column: 2 span;
}`, "",{"version":3,"sources":["webpack://./src/popups/IntegrationAthenaDetailsPopup/IntegrationAthenaDetailsPopup.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qCAAA;AACF;AACE;EACE,mBAAA;AACJ","sourcesContent":[".grid {\n  display: grid;\n  padding: 15px 30px;\n  grid-row-gap: 25px;\n  grid-column-gap: 25px;\n  grid-template-columns: repeat(3, 1fr);\n\n  .width75 {\n    grid-column: 2 span;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `IntegrationAthenaDetailsPopup-module__grid___YuKLP`,
	"width75": `IntegrationAthenaDetailsPopup-module__width75___TeBFs`
};
module.exports = ___CSS_LOADER_EXPORT___;
